import {
    ADD_AVAILABLE_UNITS_REQUEST,
    ADD_AVAILABLE_UNITS_SUCCESS,
    ADD_AVAILABLE_UNITS_FAILURE,
    GET_AVAILABLE_UNITS_REQUEST,
    GET_AVAILABLE_UNITS_SUCCESS,
    GET_AVAILABLE_UNITS_FAILURE,
    GET_AVAILABLE_UNITS_LIST_REQUEST,
    GET_AVAILABLE_UNITS_LIST_SUCCESS,
    GET_AVAILABLE_UNITS_LIST_FAILURE,
    REMOVE_AVAILABLE_UNITS_REQUEST,
    REMOVE_AVAILABLE_UNITS_SUCCESS,
    REMOVE_AVAILABLE_UNITS_FAILURE,
    EDIT_AVAILABLE_UNITS_REQUEST,
    EDIT_AVAILABLE_UNITS_SUCCESS,
    EDIT_AVAILABLE_UNITS_FAILURE
} from './constants';

export function addAvailableUnits(data) {
    return {
        type: ADD_AVAILABLE_UNITS_REQUEST,
        data: data
    }
}

export function addAvailableUnitsSuccess(response) {
    return {
        type: ADD_AVAILABLE_UNITS_SUCCESS,
        data: response
    }
}

export function addAvailableUnitsFailure(error) {
    return {
        type: ADD_AVAILABLE_UNITS_FAILURE,
        data: error
    }
}

export function getAvailableUnits(date) {
    return {
        type: GET_AVAILABLE_UNITS_REQUEST,
        data: date
    }
}

export function getAvailableUnitsSuccess(response) {
    return {
        type: GET_AVAILABLE_UNITS_SUCCESS,
        data: response
    }
}

export function getAvailableUnitsFailure() {
    return {
        type: GET_AVAILABLE_UNITS_FAILURE,
        data: {}
    }
}

export function getAvailableUnitsList(data) {
    return {
        type: GET_AVAILABLE_UNITS_LIST_REQUEST,
        data: data
    }
}

export function getAvailableUnitsListSuccess(response) {
    return {
        type: GET_AVAILABLE_UNITS_LIST_SUCCESS,
        data: response
    }
}

export function getAvailableUnitsListFailure() {
    return {
        type: GET_AVAILABLE_UNITS_LIST_FAILURE,
        data: {}
    }
}

export function deleteUnite(id) {
    return {
        type: REMOVE_AVAILABLE_UNITS_REQUEST,
        data: id
    }
}

export function deleteUniteSuccess(response) {
    return {
        type: REMOVE_AVAILABLE_UNITS_SUCCESS,
        data: response
    }
}

export function deleteUniteFailure() {
    return {
        type: REMOVE_AVAILABLE_UNITS_FAILURE,
        data: {}
    }
}

export function editUnite(data) {
    return {
        type: EDIT_AVAILABLE_UNITS_REQUEST,
        data: data
    }
}

export function editUniteSuccess(response) {
    return {
        type: EDIT_AVAILABLE_UNITS_SUCCESS,
        data: response
    }
}

export function editUniteFailure(error) {
    return {
        type: EDIT_AVAILABLE_UNITS_FAILURE,
        data: error
    }
}


// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/AvailableUnits/actions.js